import { Action } from 'components/Authorization/consts';
import { useCanAccess } from 'components/Authorization/utils';
import DeleteDialog, { DeleteDialogI } from 'components/DeleteDialog';
import i18n from 'i18n';
import { FunctionComponent } from 'react';

interface ProtectedDeleteDialogI extends DeleteDialogI {
  lnsResource?: string;
  lnsOwners?: string[];
}

export const ProtectedDeleteDialog: FunctionComponent<ProtectedDeleteDialogI> =
  ({
    lnsResource,
    lnsOwners,
    tooltip,
    btnDisabled,
    ...props
  }: ProtectedDeleteDialogI) => {
    const canAccess = useCanAccess(lnsResource, Action.DELETE, lnsOwners);

    return (
      <DeleteDialog
        lnsResource={lnsResource}
        lnsAction={Action.DELETE}
        tooltip={
          canAccess ? tooltip : i18n.t('authorization.tooltip.notAuthorized')
        }
        btnDisabled={!canAccess ? true : btnDisabled}
        {...props}
      />
    );
  };

ProtectedDeleteDialog.defaultProps = {
  lnsResource: undefined,
  lnsOwners: []
};
